/* ============================================================
   CUSTOM MENU FINDER (assets/custom-menu-finder.js)
   Filters the category menu links as you type.
   Works on the desktop bar (.cmm-finder) and in the mobile
   drawer (.cmm-m-finder). Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  function buildIndex(scope) {
    var links = scope.querySelectorAll('a[href]');
    var seen = {}, index = [];
    links.forEach(function (a) {
      var t = (a.textContent || '').trim();
      var h = a.getAttribute('href');
      if (!t || !h || h === '#') return;
      var key = t.toLowerCase() + '|' + h;
      if (seen[key]) return;
      seen[key] = 1;
      index.push({ t: t, l: t.toLowerCase(), h: h });
    });
    return index;
  }

  function attach(inputSel, resultsSel, scopeSel) {
    var input = document.querySelector(inputSel);
    var results = document.querySelector(resultsSel);
    var scope = document.querySelector(scopeSel);
    if (!input || !results || !scope) return;
    var index = null;

    function render(matches) {
      results.innerHTML = '';
      if (!matches.length) {
        results.classList.remove('is-open');
        return;
      }
      matches.slice(0, 12).forEach(function (m) {
        var a = document.createElement('a');
        a.href = m.h;
        a.textContent = m.t;
        results.appendChild(a);
      });
      results.classList.add('is-open');
    }

    input.addEventListener('input', function () {
      if (!index) index = buildIndex(scope);
      var q = input.value.trim().toLowerCase();
      if (q.length < 2) { render([]); return; }
      var starts = [], contains = [];
      index.forEach(function (m) {
        var i = m.l.indexOf(q);
        if (i === 0) starts.push(m);
        else if (i > 0) contains.push(m);
      });
      render(starts.concat(contains));
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { input.value = ''; render([]); }
    });

    document.addEventListener('click', function (e) {
      if (!results.contains(e.target) && e.target !== input) {
        results.classList.remove('is-open');
      }
    });
  }

  function init() {
    attach('.cmm-finder input', '.cmm-finder .cmm-finder__results', '.cmm-menu');
    attach('.cmm-m-finder input', '.cmm-m-finder .cmm-finder__results', '.cmm-mobile');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
